import Services from '../services'

export default {
  name: 'items_categories',
  mixins: [Services],
  data: () => ({
    categories: [],
    categories_data: [],
    category: { name: 'All categories', _id: '' },
    current_category_obj: {
      edit_index: -1,
      name: null,
      category: {
        _id: "top",
        name: "Top"
      },
      color: "#E0E0E0",
      services: [],
      image: null,
      present_type: 'color'
    },
    all_categories: [],
    page: 1,
    data_loading: false,
    all_plus_children_categories: [],
    all_top_categories: []
  }),
  methods: {
    async getTopCategories() {
      const top_categories = this.$communicator.then(
        this,
        await this.$communicator("list_of_top_categories")
      );
      if (top_categories) {
        this.all_top_categories = top_categories
      }
    },
    async getCurrentCategory(id) {
      const current_cat = this.$communicator.then(
        this,
        await this.$communicator("get_category_by_id", {
          arguments: [id]
        })
      );
      if (current_cat) {
        this.current_category_obj = { ...current_cat }
        this.current_category_obj.name = current_cat.name;
        this.current_category_obj.edit_index = current_cat._id;
        this.current_category_obj._id = current_cat._id;
        this.current_category_obj.type = current_cat.type;
        this.current_category_obj.services = current_cat.services;
        this.current_category_obj.category = { name: current_cat.parent_categories[0].name };
        this.active = current_cat.type
      }
    },
    async fetchCategories(item) {
      const children = this.$communicator.then(
        this,
        await this.$communicator("sub_categories", {
          arguments: [item._id]
        })
      );
      var childrens = []
      if (children) {
        for (const ch of children) {
          if (this.current_category_obj.edit_index != ch._id) {
            childrens.push(ch)
          }
        }
      }
      item.children = childrens
      if (item.children.length == 0) {
        delete item.children
      }
      if (typeof item.children == typeof []) {
        this.all_plus_children_categories = this.all_plus_children_categories.concat(JSON.parse(JSON.stringify(item.children)))
      }
    },
    async update_categories() {
      this.data_loading = true
      const categories = this.$communicator.then(this, await this.$communicator('list_of_categories', {
        arguments: [10, this.page]
      }))
      this.all_categories = this.$communicator.then(this, await this.$communicator('list_of_categories'))
      this.all_plus_children_categories = JSON.parse(JSON.stringify(this.all_categories))
      this.categories_data = this.$copy(categories.data)
      this.categories = [{ name: this.$t('all_categories'), _id: '' }, ...this.$copy(categories.data)]
      if (this.categories.length > 0)
        this.category = this.categories[0]
      this.data_loading = false
    },
    async categorySortedByPosition() {
      this.data_loading = true
      let categories = this.$communicator.then(this, await this.$communicator('moderator_list_of_categories'))

      function compare(a, b) {
        if (a.draggable_position > b.draggable_position) return 1;
        if (a.draggable_position < b.draggable_position) return -1;
        return 0;
      }
      categories.sort(compare);
      categories = categories.map(c => {
        return {
          ...c,
          children: c.children.sort(compare)
        }
      })
      this.all_categories = categories
      this.all_plus_children_categories = JSON.parse(JSON.stringify(this.all_categories))
      this.categories_data = this.$copy(categories)
      this.categories = [{ name: this.$t('all_categories'), _id: '' }, ...this.$copy(categories)]
      if (this.categories.length > 0)
        this.category = this.categories[0]
      this.data_loading = false
    },
    async categoriesUpdateByPosition(categories) {
      this.data_loading = true
      this.$communicator.then(this, await this.$communicator('moderator_list_of_categories_update', {
        params: categories
      }))
      this.categorySortedByPosition()
    }
  },
  mounted() {
    this.category = this.$store.state.category1 ? this.$store.state.category1 : ""
  },
  watch: {
    current_category_obj: {
      deep: true,
      handler() {
        if (
          this.current_category_obj.services &&
          this.current_category_obj.services.length == 0
        ) {
          if (this.current_category_obj && this.current_category_obj._id == undefined && this.services.length > 0) {
            this.current_category_obj.services = []
            for (const index in this.services) {
              this.current_category_obj.services.push({
                service: this.services[index]._id,
                available: true,
                service_name: this.services[index].name
              })
            }
          }
        }
      }
    },
    services: {
      deep: true,
      handler() {
        if (this.current_category_obj && this.current_category_obj._id === undefined && this.services.length > 0) {
          this.current_category_obj.services = []
          for (const index in this.services) {
            this.current_category_obj.services.push({
              service: this.services[index]._id,
              available: true,
              service_name: this.services[index].name
            })
          }
        }
      }
    }

  },
  computed: {
    choose_category() {
      return [
        { name: this.$t('all_categories'), _id: '' },
        ...this.all_categories
      ]
    },
    top_categories() {
      var all_categories = []
      for (const categ of this.all_categories) {
        if (categ._id != this.current_category_obj.edit_index) {
          all_categories.push(categ)
        }
      }
      var categories = [
        { name: 'Top', _id: 'top', type: 'top' }, ...all_categories
      ]
      return categories
    }
  }
}
